import React from 'react';
import PropTypes from 'prop-types';
import Select from '@domain-group/fe-co-select';
import { PlusIcon, CalendarIcon } from '@domain-group/fe-co-icon';
import * as styles from '../../styles/homepass-booking/homepass-booking-structure';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SelectInspection = props => {
  function renderOption(item, index, highlightedIndex, selectedItem, getItemProps) {
    return [___EmotionJSX("div", getItemProps({
      item,
      css: styles.optionButtonText
    }), item.label),
    // insert this button at the end of the list
    props.hasAvailableCalendarEvents && index === props.options.length - 1 ? ___EmotionJSX("button", {
      onClick: props.launchCustomDateDialog,
      css: styles.customOption,
      type: "button"
    }, ___EmotionJSX(PlusIcon, {
      size: "small",
      css: styles.optionPlusIcon
    }), "Request another time") : null].filter(Boolean);
  }

  // kinda hack to show a availableCalendarEvent as selected even though
  // it's not part of the dropdown
  var isAvailableCalendarEvent = props.selectedAvailableCalendarEventLabel;
  return ___EmotionJSX("section", {
    css: styles.selectInspection(isAvailableCalendarEvent)
  }, ___EmotionJSX("div", {
    css: styles.inspectionTitle
  }, "Select an inspection"), ___EmotionJSX("div", {
    css: styles.inspection
  }, ___EmotionJSX(CalendarIcon, {
    size: "regular",
    css: styles.calendarIcon
  }), ___EmotionJSX(Select, {
    options: props.options,
    onChange: props.onChange,
    value: props.value,
    placeholder: props.selectedAvailableCalendarEventLabel || 'Please select a date',
    css: styles.selectControl(props.fieldError)
    // eslint-disable-next-line react/jsx-no-bind
    ,
    optionComponent: renderOption,
    labelHidden: true,
    label: "Select inspection date"
  }), props.fieldError && ___EmotionJSX("div", {
    css: styles.selectErrorMessage
  }, "Please select a date")));
};
SelectInspection.propTypes = {
  options: PropTypes.array.isRequired,
  // eslint-disable-line
  value: PropTypes.string,
  selectedAvailableCalendarEventLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  launchCustomDateDialog: PropTypes.func.isRequired,
  fieldError: PropTypes.bool.isRequired,
  hasAvailableCalendarEvents: PropTypes.bool.isRequired
};
SelectInspection.defaultProps = {
  selectedAvailableCalendarEventLabel: undefined,
  value: null
};
export default SelectInspection;